import {Page} from '../../layout/components';
import React from 'react';

export default function NotAuthorizedPage() {
  return (
    <Page pageClassName="not-authorized-page">
      <h1>You are not authorized to access this resource.</h1>
    </Page>
  );
}



// WEBPACK FOOTER //
// ./app/features/authentication/components/NotAuthorizedPage.js